import React from "react";
import { Row, Col } from "react-bootstrap";

const MensagemErro = ({ mensagem }) => {
  if (!mensagem) return null;

  return (
    <div className="resultado-simulacao-emprestimo" style={{ marginTop: "10px" }}>
      <Row>
        <Col sm={12}>
          <div className="alert alert-danger" role="alert">
            <span>
              <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
            </span>
            <span style={{ marginLeft: "10px" }} dangerouslySetInnerHTML={{ __html: mensagem }}></span>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default MensagemErro;